import { Linktrainrelaymixer } from '@linktivity/eticketportal';

export type Station = Linktrainrelaymixer.Station;
export type Diagram = Linktrainrelaymixer.Diagram;
export type DiagramCarInfo = Linktrainrelaymixer.DiagramCarInfo;
export type SeatClass = Linktrainrelaymixer.SeatClass;
export type SeatPreference = Linktrainrelaymixer.SeatPreference;
export type SeatMapSeat = Linktrainrelaymixer.SeatMapSeat;
export type CommonReq = Linktrainrelaymixer.CommonReq;
export type GetOrderParametersResp = Linktrainrelaymixer.GetOrderParametersResp;
export type BookingInfo = Linktrainrelaymixer.GetOrderDetailsResp & {
  bookingId?: string;
};

export type RemainStatus = Linktrainrelaymixer.RemainStatus;
export const RemainStatus = Linktrainrelaymixer.RemainStatus;

export interface TimeRange {
  from: string;
  to: string;
}

export const SeatSelectionMode = {
  Preference: 'preference',
  SeatMap: 'seatMap'
} as const;
export type SeatSelectionMode =
  (typeof SeatSelectionMode)[keyof typeof SeatSelectionMode];

export interface BookingSelection {
  fromStation?: Station;
  toStation?: Station;
  routeReversed?: boolean;
  diagram?: Diagram;
  seatClass?: SeatClass;
  seatSelectionMode?: SeatSelectionMode;
  seatPreference?: SeatPreference;
  carId?: string;
  selectedSeatIds?: string[];
}
